import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from, Subject } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { HashService } from 'src/app/_services/hash.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { JdData } from 'src/app/common-interfaces-classes/JdData';
import { TextExtractResponse } from 'src/app/common-interfaces-classes/TextEtractResponse';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { GenAiJdSearchComponent } from 'src/app/gen-ai-jd-search/gen-ai-jd-search.component';
import { JdDataService } from 'src/app/jd-data.service';
import { jdParserResponse } from 'src/app/person-search/jd-search/jd-search.component';
import { SimilarCandidateFilterComponent } from 'src/app/similar-candidate-filter/similar-candidate-filter.component';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FilterResponseMapperServiceService } from '../filter-response-mapper-service.service';
import { FilterStoreService } from '../store/filter-store.service';
import { RequestServiceService } from '../request-service.service';
import { AggregateRequestStoreService } from '../store/aggregate-request-store.service';
import cjson from 'compressed-json';


@Component({
  selector: 'app-hire-jd-search',
  imports: [CommonModule, FormsModule],
  templateUrl: './hire-jd-search.component.html',
  styleUrl: './hire-jd-search.component.scss',
})
export class HireJdSearchComponent {
isUploadedFileCorrect = false;
  incorrectFileFormat = false;
  specialCharaterError = false;
  fileSizeLimitExceeded = false;
  jdDataLoading = false;
  textExtractionError = false;

  uploadedFilename: string;
  uploadedFile = null;

  enteredJobDescription: string;

  textExtractionErrorMessage: string;

  showHistoryViewAll: any;
  showSavedHistoryViewAll: any;
  historySubject = new Subject<any>();
  savedHistorySubject = new Subject<any>();

  isTalentInsightsModule: boolean = false;
  @Input() calledFrom: string = null;

  constructor(
    private searchtoolbox: SearchtoolboxService, public modalService: NgbModal,
    private hashService: HashService, private jdDataService: JdDataService,
    private router: Router, private activatedRoute: ActivatedRoute, private personSearchService: PersonSearchService,
    private location: Location, private route: ActivatedRoute, private filterResponseMapperService: FilterResponseMapperServiceService,
    private filterStoreService: FilterStoreService, private requestService: RequestServiceService, private aggregateRequestStoreService: AggregateRequestStoreService

  ) { }

  ngOnInit() {
    if (this.router.url.includes('talentpool-insights')) {
      this.isTalentInsightsModule = true;
    }
  }

  get isComingFromJD() {
    return this.jdDataService.isComingFromJobDescription;
  }

  resetFormFields() {
    this.incorrectFileFormat = false;
    this.specialCharaterError = false;
    this.isUploadedFileCorrect = false;
    this.uploadedFilename = null;
    this.fileSizeLimitExceeded = false;
    this.enteredJobDescription = "";
  }

  uploadFile(event) {
    this.resetFormFields();
    const file: File = event.target.files[0];
    this.uploadedFile = GlobalService.validateAndSanitizeFile(file);
    this.validateInputFile();

    if (this.uploadedFile && !this.specialCharaterError && !this.incorrectFileFormat && !this.fileSizeLimitExceeded) {
      this.isUploadedFileCorrect = true;
      this.uploadedFilename = file.name;
      this.jdDataLoading = true;
      this.searchtoolbox.documentToText(this.uploadedFile).subscribe((response: TextExtractResponse) => {
        this.jdDataLoading = false;
        this.processTextractResponse(response);
      }, () => this.jdDataLoading = false);
    }
  }

  private validateInputFile() {
    const validFileExtensions = ['doc', 'docx', 'pdf', 'txt', 'odt'];
    const uploadedFileExtension = this.uploadedFile.name.split('.').pop();

    if (!validFileExtensions.includes(uploadedFileExtension.toLowerCase())) {
      this.incorrectFileFormat = true;
    }
    // Verify file size (File size cannot exceed 5 MB)
    if (this.uploadedFile.size > 5242880) {
      this.fileSizeLimitExceeded = true;
    }
  }

  private processTextractResponse(response: TextExtractResponse) {
    if (response.status === "success") {
      this.enteredJobDescription = response.text;
      this.textExtractionError = false;
      this.textExtractionErrorMessage = null;
    }
    else if (response.status === "failure") {
      this.textExtractionError = true;
      this.textExtractionError = true;
      this.textExtractionErrorMessage = response.message;
    }
  }

  get isDescriptionEmpty() {
    return !this.enteredJobDescription || this.enteredJobDescription?.toString()?.trim()?.length === 0;
  }

  addJobDescription() {
    if (this.isDescriptionEmpty) return;
    this.getJDKeywordsAI(this.enteredJobDescription.toString().trim());
  }

  private getJDKeywordsAI(description: string = null) {

      this.aggregateRequestStoreService.userQuery.set(description) ;
      this.aggregateRequestStoreService.loading.set(true);
      this.redirectToSearchResults();
   }

  checkHistory(event, saveMode: boolean = false) {
    if (event === 'REFRESH') {
      this.savedHistorySubject.next(event);
    } else {
      this[saveMode ? 'showSavedHistoryViewAll' : 'showHistoryViewAll'] = event;
    }
  }

  viewAllHistory(saveMode: boolean = false) {
    this[saveMode ? 'savedHistorySubject' : 'historySubject'].next(undefined as any);
  }

  /**
   * Used to convert new Jd parser (Groq) in the form of preivously used JD parser(openAi)
   * @param jdResp
   * @returns
   */
  convertJdResponse(jdResp: jdParserResponse): JdData {
    if (!jdResp || jdResp.status !== 'success' || !jdResp.data) {
      throw new Error("Invalid Jd parse response format.");
    }

    const data = jdResp.data;
    let mergeJobTitles = data?.jobtitles?.slice(1) || [];
    mergeJobTitles = mergeJobTitles.concat(mergeJobTitles, data?.suggestedjobtitle || [])
    const jdData = {
      "Job Title": data.jobtitles?.[0] || null,
      "Suggested job Title": mergeJobTitles,
      "Preferred Skills": data.preferredskills || [],
      "Tools": data.tools.length ? data.tools : null,
      "Years of experience": {
        "minimum experience": data.yearsofexperience?.min ?? null,
        "maximum experience": data.yearsofexperience?.max ?? null
      },
      "Relevant Year of experience": {
        "minimum experience": data.yearsofexperience?.min ?? null,
        "maximum experience": data.yearsofexperience?.max ?? null
      },
      "Industry": data.industries || [],
      "Location": {
        "city": null,
        "state": null,
        "country": null,
        "continent": data.continents?.[0] || null
      },
      "Target Company": data.companies.length ? data.companies : [],
      "Degree": data.educationaldegrees || [],
      "Field of study": data.fieldofstudy || [],
      "School": data.schools.length ? data.schools : null,
      "Mandatory Skills": data.mandatoryskills || [],
      "exactLocationMatch": data.exactlocationmatch || null,
      "normalizedlocations": data.normalizedlocations || [],
      "normalizedcontinents": data.normalizedlocations.map(loc => loc.continent) || []
    };
    return {
      status: 'success',
      jdData: jdData
    }
  }



  redirectToSearchResults() {
    this.modalService.dismissAll();
    if(this.calledFrom && this.calledFrom === 'talent-insights') {
  this.router.navigate(
          ['/talent-insights/overview'],
          {
            queryParams: {
              type: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION,
            },
          }
        );
    } else {
  this.router.navigate(
          ['/candidate-list'],
          {
            queryParams: {
              type: GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION,
            },
          }
        );
    }


  }

}
